import { setCookieDomain, setRestHost } from './shared/utils';

let rest_host = process.env.REACT_APP_REST_HOST;
if ('443' !== process.env.REACT_APP_REST_USER_PORT_HTTPS) {
  rest_host = rest_host + ':' + process.env.REACT_APP_REST_USER_PORT_HTTPS;
}

export const mqttIoTEndpoint = process.env.REACT_APP_IOT_ENDPOINT
  ? process.env.REACT_APP_IOT_ENDPOINT
  : '';
// Set to a wss:// mosquitto URL in dev to use the local broker instead of AWS IoT.
export const localMqttUrl = process.env.REACT_APP_LOCAL_MQTT_URL || '';
export const restHost = rest_host ? rest_host : '';

let chatbot_host = process.env.REACT_APP_CHATBOT_API_HOST;
if (chatbot_host && '443' !== process.env.REACT_APP_CHATBOT_API_PORT) {
  chatbot_host = chatbot_host + ':' + process.env.REACT_APP_CHATBOT_API_PORT;
}
export const chatbotHost = chatbot_host ? chatbot_host : '';

setRestHost(restHost);
setCookieDomain(
  process.env.REACT_APP_COOKIE_DOMAIN
    ? process.env.REACT_APP_COOKIE_DOMAIN
    : '',
);
